import { render } from "./ListMawbsModal.vue?vue&type=template&id=13c1483c&scoped=true"
import script from "./ListMawbsModal.vue?vue&type=script&lang=js"
export * from "./ListMawbsModal.vue?vue&type=script&lang=js"

import "./ListMawbsModal.vue?vue&type=style&index=0&id=13c1483c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13c1483c"]])

export default __exports__